import heart_line from '../../../favicon/heart_line.svg'
import favorite_fill from '../../../favicon/favorite_fill.svg'
import cardImg from '../../../Image/cardImg.png'
import cardlog from '../../../Image/card_log.png'
import cancel from '../../../favicon/cancel.svg'
import age from '../../../favicon/age.svg'
import profession from '../../../favicon/profession.svg'
import location from '../../../favicon/location.svg'
import gender from '../../../favicon/gender.svg'
import question2 from '../../../favicon/question2.svg'
import marital_status from '../../../favicon/marital_status.svg'
import currencyFormatter from "../../../Helpers/currencyFormatter";
import Countdown from 'react-countdown'
import { motion } from "framer-motion";


const BrandDetailModal = ({ ...props }) => {
    const { item, showTaskRequests, showModal, setShowModal, setShowSocialPlatform, markFavorite } = props;
    const getRemainingPoolAmount = (item) => {
        let amount = 0.00;
        if (item?.taskRequests?.length > 0) {
            amount = item?.taskRequests?.filter(t => t.status === 'Approved')?.reduce((acc, curr) => (acc + parseFloat(curr?.total_cash_eraned)), 0.00);
        }
        const remainingPool = parseFloat(item?.budget) - amount
        return currencyFormatter.format(remainingPool);
    }

    const getTrackLinkColor = (social_platform_id) => {

        if (social_platform_id === 1)
            return 'linkBlue';
        if (social_platform_id === 2)
            return 'linkRed';
        if (social_platform_id === 3)
            return 'linkBlack';
    }

    const selectSocialPlatform = (range) => {
        setShowSocialPlatform(range)
    }

    const Completionist = () => <span className='text-red-700  font-museob'>Campaign duration ended !</span>;
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <Completionist />;
        } else {
            // Render a countdown
            return <div className='flex border px-2 border-black rounded-lg text-white bg-black'>
                <span className='mr-1'><strong className='font-museobb'>{days}</strong> d  <span className='animate-pulse'>:  </span> </span>
                <span className='mr-1'><strong>{hours}</strong> h  <span className='animate-pulse'>: </span> </span>
                <span className='mr-1'><strong>{minutes}</strong> m  <span className='animate-pulse'>:  </span> </span>
                <span className='mr-1'><strong>{seconds}</strong> s </span>

            </div>;
        }
    };



    return (
        <>
            {showModal ? (
                <>
                    <div className=" justify-center  items-center flex flex-col fixed  inset-0 z-50 outline-none focus:outline-none">
                        <div className=" flex justify-end pr-4 pb-2 md:pr-8 md:pb-3  w-full " ><img onClick={() => setShowModal(false)} src={cancel} alt="cancel_img" className=" transition ease-in-out hover:scale-110  duration-300  cursor-pointer"></img></div>
                        <motion.div initial={{ opacity: 0, scale: 0.75, y: -200 }} animate={{ opacity: 1, scale: 1, y: 0 }} exit={{ opacity: 0, scale: 0, y: 200 }} transition={{ ease: "easeOut", duration: 0.3 }}
                        className="w-[95%] pr-2 rounded-lg bg-white ">
                            <div className="sbar overflow-x-hidden max-h-[88vh] overflow-y-auto 
                              bg-white rounded-lg "  >
                                <div className='font-museo '>
                                    <div className=" px-4 md:px-0
                                        md:grid md:grid-cols-4  md:grid-rows-1  
                                       " style={{ "boxShadow": "rgb(210 206 206 / 82%) 3px 5px 20px 1px" }} >
                                        <div className=" flex justify-center md:justify-start ">
                                            <img className="p-1 h-[200px] object-cover object-top w-[350px] rounded-xl" src={item?.campaignLogo ? item?.campaignLogo : cardImg} alt="campaign_log" />
                                        </div>
                                        <div className="md:col-start-2 md:col-end-5 md:grid md:grid-cols-1 md:grid-rows-8  " >
                                            <div className="md:row-start-1 md:row-end-7">

                                                <div className="md:grid md:grid-cols-3 md:grid-row-1 h-full  border-b-2 mr-5 py-3 " >

                                                    <div className=" col-start-1 col-end-3 md:pl-5 pl-3 md:max-w-[75%] grid items-stretch">
                                                        <h5 className="text-[#178ACB] text-lg font-museobb  ">{item?.campaign_title}</h5>

                                                        <div>
                                                            <p className="text-gray-600 font-museob ">{item?.description}</p>
                                                            <span className="text-gray-600 font-museob  ">Live Date: {item?.live_date}</span><br></br>
                                                            <span className="text-gray-600 font-museob  ">Duration: {item?.duration_start_date} ~ {item?.duration_end_date}</span>
                                                        </div>


                                                        <div className="flex gap-2 flex-wrap  items-end py-2 md:py-0 ">
                                                            {item?.allocatedBudget?.map((range, it) => (
                                                                <span key={`range-${it}`} className="bg-[#66BE9C] px-2 py-1  text-white  md:text-[10px] font-museob text-center  rounded-full">{range?.soical_paltfom}</span>
                                                            ))}
                                                        </div>

                                                    </div>

                                                    <div className=" md:justify-end md:content-between md:grid items-center md:justify-items-end
                                                          flex justify-between  md:mt-0   md:my-3   ">
                                                        <img src={item?.brand_logo ? item?.brand_logo : cardlog} alt='brand_logo' className="w-16 object-cover object-center max-h-16"></img>
                                                        <div className='cursor-pointer  ' >
                                                            {item?.is_favorite
                                                                ?
                                                                (<img alt='fav' className='w-7 h-7 heart' onClick={(e) => { e.preventDefault(); markFavorite(item?.id) }} src={favorite_fill} />)
                                                                :
                                                                (<img alt='fav_filled' className='w-7 h-7  ' onClick={(e) => { e.preventDefault(); markFavorite(item?.id); }} src={heart_line} />)}
                                                        </div>
                                                    </div>


                                                </div>


                                            </div>

                                            <div className="flex flex-col sm:flex-row  sm:items-center justify-between gap-y-2 md:gap-y-0 py-2 px-4 ">
                                                <p className='sm:text-md font-museob text-slate-600  text-sm'>{item?.category_id}</p>
                                                <div className='flex sm:gap-x-5 items-center justify-between'>
                                                    <Countdown
                                                        date={new Date(item?.duration_end_date).getTime()}
                                                        renderer={renderer}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className=' mx-10'>
                                        <div className=' py-5 md:py-10 font-museobb border-b  flex md:flex-row flex-col md:justify-start justify-center md:items-center 
                                        md:divide-y-0 divide-y-2 divide-gray-400 divide-opacity-75 md:w-full w-fit'>

                                            <div className=' py-2 md:py-0 md:pr-10 md:border-r-2 border-gray-400  '>
                                                <div className='text-start'>
                                                    <p>Grand Cash Pool</p>
                                                    <h3 className='text-[#40BA47] tracking-wider'>RM {currencyFormatter.format(item?.budget)}</h3>
                                                </div>
                                            </div>

                                            <div className='md:px-10 py-3  md:py-0 md:border-r-2  border-gray-400  ' >
                                                <div className='text-start'>
                                                    <p >Remaining Cash Pool</p>
                                                    <h3 className='text-[#FF9E00]  tracking-wider mr-0 ' >RM {currencyFormatter.format(item?.campagin_wallet_balcance)}</h3>
                                                </div>
                                            </div>
                                            <div className='md:pl-10 py-2 md:py-0 '>
                                                <div className=' text-start'>
                                                    <p>Bonus Cash Pool</p>
                                                    <h3 className='text-[#A8842E] tracking-wider' >RMXXXXX</h3>
                                                </div>
                                            </div>


                                        </div>



                                        <div className=" font-museo py-5 border-b  ">

                                            <div className='md:h-10  h-8 font-museobb flex items-center '><h4>Tasks</h4>
                                                <img src={question2} alt="question_mark_img" className=" transition ease-in-out delay-150  hover:scale-125 hover:translate-x-1  duration-300 cursor-pointer" ></img>

                                            </div>

                                            {item?.allocatedBudget?.map((range, it, i) => (
                                                <div key={`range-for-${range?.soical_paltfom}`} >
                                                    <div className='my-2 pt-2 cursor-pointer' onClick={() => { selectSocialPlatform(range) }}>
                                                        <p className={`${getTrackLinkColor(range?.soical_paltfom_id)} hover:[#64aa7d] w-28 h-8 inline-flex justify-center items-center text-center text-white text-xs font-museob tracking-wider rounded-xl `}>
                                                            {range?.soical_paltfom}
                                                        </p>
                                                    </div>
                                                    {(range?.selected) && (
                                                        <div className=' grid md:grid-cols-3 md:grid-rows-1  grid-cols-1 grid-rows-auto  h-full gap-x-5  gap-y-5 '>
                                                            {range?.items?.map((r, it, i) => (
                                                                <div key={`${range?.soical_paltfom}-${r?.range_for} -${i}`} className={`grid  grid-rows-7  `}>


                                                                    <div className='my-2'>

                                                                        <div className="flex flex-col  ">
                                                                            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8 ">

                                                                                <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8 ">

                                                                                    <div className="overflow-hidden inline-block min-w-full align-middle border-b border-gray-200 shadow sm:rounded-lg">
                                                                                        <table className="min-w-full table-auto">

                                                                                            <thead className="border-b">
                                                                                                <tr className="w-full " >
                                                                                                    <th colSpan="3">
                                                                                                        <div className=' p-2 bg-[#66BE9C]  '>
                                                                                                            <span className=' font-medium text-white font-museob text-sm px-6 py-4  '>
                                                                                                                {r?.range_for}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </th>


                                                                                                </tr>

                                                                                                <tr>
                                                                                                    <th colSpan="3" >
                                                                                                        <div className='text-sm font-medium text-gray-900 px-6 py-4 text-left  '>
                                                                                                            {r?.range[0]?.task}
                                                                                                        </div>
                                                                                                    </th>
                                                                                                </tr>

                                                                                                <tr>

                                                                                                    <th scope="col" className="px-6 py-3 text-xs font-museobb leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                                                                                        From
                                                                                                    </th>

                                                                                                    <th scope="col" className="px-6 py-3 text-xs font-museobb leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                                                                                        To
                                                                                                    </th>

                                                                                                    <th scope="col" className="px-6 py-3 text-xs font-museobb leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                                                                                                        Amount
                                                                                                    </th>

                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>


                                                                                                {r?.range.map((rangeData) => (
                                                                                                    <tr key={`dasd-${range?.soical_paltfom}-${r?.range_for}-${rangeData?.id}-s`} className="border-b">
                                                                                                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{rangeData?.from}</td>

                                                                                                        <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap">
                                                                                                            {rangeData?.to}
                                                                                                        </td>
                                                                                                        {/* <td className="text-sm text-gray-900 font-light px-6 py-4 whitespace-nowrap"> */}
                                                                                                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                                                                                                            <span className="inline-flex px-2 text-xs font-semibold leading-5 text-green-800 bg-green-100 rounded-full">RM  {currencyFormatter.format(rangeData?.amount)}</span>
                                                                                                        </td>

                                                                                                    </tr>
                                                                                                ))}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>




                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>

                                        <div className='py-5  ' >

                                            <div className='font-museobb flex'><h4>Requirements</h4>
                                            <img src={question2} alt="question_mark_img" className=" transition ease-in-out delay-150  hover:scale-125 hover:translate-x-1  duration-300 cursor-pointer" ></img>
                                            </div>

                                            <div className='font-museob items-center  grid md:grid-cols-5 md:gap-x-2  grid-cols-auto grid-rows-auto gap-y-5 md:gap-y-0   mt-2 '>

                                                <div className='  flex  h-full font-museo '>
                                                    <img alt='age' src={age} className="mr-2 w-10 h-10" ></img>
                                                    <div>
                                                        <span className="font-museobb" >Age</span><br></br>
                                                        <p className="relative font-museob top-0">{item?.age?.map((age, i) => (
                                                            <span key={`age-text-${i}`}> {age}  years old {i < (item?.age?.length - 1) ? '/' : ''}</span>
                                                        ))}</p>
                                                    </div>
                                                </div>

                                                <div className='flex  h-full font-museo '>
                                                    <img alt='gender' src={gender} className="mr-2 w-10 h-10" ></img>
                                                    <div>
                                                        <span className="font-museobb" >Gender</span><br></br>
                                                        <p className="relative font-museob top-0">{item?.gender?.map((gender, i) => (
                                                            <span key={`gender-text-${i}`}> {gender} {i < (item?.gender?.length - 1) ? '/' : ''}</span>
                                                        ))}</p>

                                                    </div>
                                                </div>

                                                <div className='flex h-full font-museo '>
                                                    <img alt='location' src={location} className="mr-2 w-10 h-10" ></img>
                                                    <div>
                                                        <span className="font-museobb" >Location</span><br></br>
                                                        <p className="relative font-museob top-0">{item?.location}</p>
                                                    </div>
                                                </div>



                                                <div className='flex  h-full font-museo '>
                                                    <img alt='profession' src={profession} className="mr-2 w-10 h-10" ></img>
                                                    <div>
                                                        <span className="font-museobb" >Profession</span><br></br>
                                                        <p className="relative font-museob top-0">{item?.occupation?.map((occupation, i) => (
                                                            <span key={`occupation-text-${i}`}> {occupation} {i < (item?.occupation?.length - 1) ? '/' : ''}</span>
                                                        ))}</p>
                                                    </div>
                                                </div>
                                                <div className='flex  h-full font-museo '>
                                                    <img alt='marital_status' src={marital_status} className="mr-2 w-10 h-10" ></img>
                                                    <div>
                                                        <span className="font-museobb" >Martial Status</span><br></br>
                                                        <p className="relative font-museob top-0">{item?.marital_status?.map((marital_status, i) => (
                                                            <span key={`marital_status-text-${i}`}> {marital_status} {i < (item?.marital_status?.length - 1) ? '/' : ''}</span>
                                                        ))}</p>
                                                    </div>
                                                </div>

                                            </div>



                                        </div>
                                    </div>

                                    <div className="flex justify-center items-center py-3  border-t " >

                                        {item?.taskRequests.length > 0 ? (

                                            <div onClick={() => showTaskRequests(item)} className='bg-greenBtn flex px-10 py-4 rounded-l-full rounded-r-full gap-x-2 cursor-pointer
                                                i  overflow-hidden transform  hover:scale-x-105 hover:scale-y-105 transition duration-300 ease-out' >
                                                <p className='text-white font-museob tracking-widest ' >View All request</p>
                                                <p className='text-blue-800 font-museob p-0 m-0 bg-white w-5 h-5 text-center rounded-full ' >{item?.taskRequests.length}</p>
                                            </div>

                                        ) : (
                                            <div className='bg-[#BCBCBB]  flex px-10 py-4 rounded-l-full rounded-r-full gap-x-2 ' >
                                                <p className='font-museobb text-white ' >No Requests yet</p>
                                            </div>
                                        )}


                                    </div>

                                </div >

                            </div>
                        </motion.div>
                    </div>
                    <div className="opacity-60 fixed inset-0 z-40 bg-black duration-150 ease-in-out transition  active:shadow-lg "></div>
                </>
            ) : null}
        </>


    )

};



export default BrandDetailModal;
